// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"5a8357e1","479":"b3e544f2","488":"31278821","727":"3bec06ab","910":"3cf5d979","919":"7ccbb1b4"}[chunkId] + ".chunk.js";
};